import { API_BASE } from "../AppConfig";

const apiSync = ({ id, json }) => {
    fetch(API_BASE() + "test/" + id, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ jobs: json, id: id, DocumentType: "AUTO_TESTING" }),
    })
        .then(async (response) => {
            if (response.status >= 200 && response.status <= 300) {
                console.log("SUCCESS: RESYNC " + id);
            }
        })
        .catch((e) => {
            console.log("FAILED: RESYNC " + id);
        });
};

export const apiGetTest = ({ id }) => {
    return fetch(API_BASE() + "test/" + id, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then(async (response) => {
            if (response.status >= 200 && response.status <= 300) {
                const data = await response.json(); // Parse the JSON response
                if (data.jobs) return data.jobs; // Return the 'jobs' property
            }
            return null; // Returning null or another appropriate value in case of failure
        })
        .catch((e) => {
            console.log("FAILED: RESYNC " + id);
            throw e; // Re-throw the error for further handling
        });
};

export const getBomTest = async () => {
    return await apiGetTest({ id: window.brand + "_bom_test_jobs" });
};

export const getLoadTest = async () => {
    return await apiGetTest({ id: window.brand + "_load_test_jobs" });
};

// Resets the BOM to the returned new BOM
export const syncBomTest = ({ newBom }) => {
    apiSync({ id: window.brand + "_bom_test_jobs", json: newBom });
};

// Resets the Loads to the returned new engineering loads
export const syncLoadTest = ({ newLoad }) => {
    apiSync({ id: window.brand + "_load_test_jobs", json: newLoad });
};
